export const COLORS = {
  light: {
    axis: "#666666",
    grid: "#e5e7eb",
    textColor: "#333333",
  },
  dark: {
    axis: "#cccccc",
    grid: "#374151",
    textColor: "#ffffff",
  },
};
